import React from 'react';
import { Text, Dimensions } from 'react-native';
import { withRouter } from "react-router-dom";

import {Button, Card, ImageDisplay, ProgressBar} from "../../../components";
import Colors from "../../../constants/Colors";
import {JOURNEY_GET_THUMBNAIL} from "../api/journeyEndpoints";

const JourneyInProgressComponent = (props) => {

    const { title, id } = props.data;
    const { items, userProgress } = props.data;

    const { height, width } = Dimensions.get('window');
    const barWidth = 500;

    return (
        <Card containerStyle={{ backgroundColor: Colors.cardBackgroundColor, margin: 20, marginTop: 4, marginBottom: 4,  }}>

            <Text style={{ textAlign: 'center', fontSize: 22, fontWeight: 'bold', marginBottom: 8, color: 'white' }}>
                { title }
            </Text>

            <ImageDisplay
                imageUrl={JOURNEY_GET_THUMBNAIL(id)}
                propsContainerStyle={{ height: 300, width: 500, borderRadius: 8 }}
                propsImageStyle={{ height: 300, width: 500, borderRadius: 8 }}
            />

            <ProgressBar
                statTitle={'Progresso'}
                barSize={barWidth}
                currentAmount={userProgress === null ? 0 : userProgress.length}
                maxAmount={items.length}
            />

            <Button
                text={'Acessar'}
                onPress={() => {
                    props.history.push(`/journey/hub?journeyId=${id}`)
                    // props.fetchJourneyAndUserProgress(id);
                }}
                containerPropsStyle={{ height: 30, borderRadius: 8}}
                textPropsStyle={{ fontSize: 18 }}
            />

        </Card>
    )

}

export default withRouter(JourneyInProgressComponent);
